import React, { Component } from "react";
import { createStyles, withStyles, WithStyles } from "@material-ui/core";
import { Grid, Theme, Tabs } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    tabContainer: {
      position: 'relative',
      lineHeight: 0,
    }  
  });

interface Props extends WithStyles<typeof styles> {
  defaultSelected: string;
  activeTab?: string;
  handleActiveTabChange?: (activeTab: string) => void;

}
interface State {
    activeTab: any;
}

class MyPATTabs extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      activeTab: props.activeTab || '',
    };
  }

    componentDidUpdate(prevProps: any) {
      if (prevProps.activeTab !== this.props.activeTab) {
        this.setState({
          activeTab: this.props.activeTab,
        });
      }
    }
    handleActiveTabChange(eventKey: string) {
      if (this.props.handleActiveTabChange) {
        this.props.handleActiveTabChange(eventKey);
      } else {
        this.setState({
          activeTab: eventKey
      })
      }
    }
  render() {
    const { children, classes, defaultSelected } = this.props;
    const { activeTab } = this.state;
    return (
      <>
      <Grid container className={classes.tabContainer}>
        {React.Children.map(children, (child, i) => {
          if(!child) return null;
        // @ts-ignore
        let defaultValue = defaultSelected === child.props.eventKey;
        // @ts-ignore
        const isActive = activeTab ? (activeTab === child.props.eventKey) : defaultValue;
        // @ts-ignore
        let selectedChild = isActive && child.props.children;
          // @ts-ignore
           let clonedChild =  React.cloneElement(child, {
                setActiveTab: () => {
            // @ts-ignore
                  this.handleActiveTabChange(child.props.eventKey) 
                },
                activeTab,
                defaultValue
              });
          return (
            <>
              <Grid item>
                  {clonedChild}
​
                </Grid>
​
                {
                  // @ts-ignore
                  isActive && child.props.children
                }
             </>
          );
        })}
      </Grid>
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(MyPATTabs);
